import { BaseState, StateManager } from '@app/store/shared';
import { createReducer, on } from '@ngrx/store';
import { nextActions } from '../actions/next.actions';

export type NextState = BaseState<{
    courseId: string | null;
    moduleId: string | null;
    lessonId: string | null;
}>;

const initialNextState: NextState = StateManager.initial();

export const nextReducer = createReducer(
    initialNextState,

    on(nextActions.getNextContent, (state): NextState => ({ ...StateManager.setLoading(state) })),
    on(nextActions.getNextContentSuccess, (state, { payload }): NextState => ({ ...StateManager.setLoaded(state, payload) })),
    on(nextActions.getNextContentError, (state): NextState => ({ ...StateManager.setError(state) })),

    on(nextActions.clear, (): NextState => ({ ...initialNextState })),
);
